import Breadcrumb from "component/common/breadcrumb";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  getRaiseTicketDetail,
  replySupportTicket,
  replySupportTicketRemove,
} from "reduxStore/action/raiseTicket(Support)Actions";
import strings from "translate/language";
import usePermission from "utils/usePermission";
import { raiseTicketStatus } from "utils/constants";
import { handleListResponse, seo } from "utils/utils";

const UpdateStatus = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState({});
  const [viewData, setViewData] = useState({});
  const ticketId = new URLSearchParams(window.location.search).get("ticket_id");
  const {  isAdmin } = usePermission({});

  const navigatpage = async (navname) => {
    navigate(navname);
  };
  const raiseTicketDetailSelector =
    useSelector((state) => state.raiseTicket) || {};

  const [form, setForm] = useState({
    status: "",
    remark: "",
  });

  useEffect(() => {
    const { response, updateTicketresponse = null } = raiseTicketDetailSelector;
    if (raiseTicketDetailSelector.response) {
      if (response?.status === 200) {
        setViewData(handleListResponse(response.data.reply_support_ticket));
      } else {
        setViewData([]);
      }
      if (updateTicketresponse && updateTicketresponse?.status === 200) {
        dispatch(replySupportTicketRemove());
        if(isAdmin){
          navigatpage("/raise_ticket");
        }else{
          navigatpage("/support_request")
        }
      }
    }
  }, [raiseTicketDetailSelector]);

  useEffect(() => {
    dispatch(getRaiseTicketDetail({ ticket_id: ticketId }));
  }, []);

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
  };

  const raiseTicketUpdate = () => {
    if (!handleValid()) {
      const post = {
        ticket_id: ticketId,
        status: form.status,
        remark: form.remark,
      };
      dispatch(replySupportTicket(post));
    }
  };

  const handleValid = () => {
    let err = {};
    let formError = false;
    if (form.status === "") {
      formError = true;
      err["status"] = strings.statusErr;
    }
    if (!form.remark) {
      formError = true;
      err["remark"] = strings.remarkErr;
    }
    setFormVaild(err);
    return formError;
  };

  useEffect(() => {
    seo({
      title: "Update Raise Ticket",
      metaDescription: "Update raise ticket",
      canonicalLink: window.location.href,
    });
  }, []);

  return (
    <div className="page-body">
      <Breadcrumb
        title={strings.updateSupportticket}
        url={"/raise_ticket"}
        parentListing={strings.raiseTicketList}
        titleactive={strings.updatesupportticket}
        isBackBtn={true}
      />
      <div className="container-fluid">
        <div className="row ">
          <div className="col-sm-12 ">
            <div className="card">
              <div className="card-header">
                <h5>{strings.updateSupportticket}</h5>
              </div>
              {raiseTicketDetailSelector?.response?.data?.status === 1 && (
                <form className="form theme-form">
                  <div className="card-body">
                    <div className="row ">
                      <div className="col-md-8 ">
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlFirstName">
                            {strings.selectStatus}
                            <span className="required-field"></span>
                          </label>
                          <select
                            className="form-control btn-square"
                            id="formcontrol-select1"
                            name="status"
                            value={form.status}
                            onChange={handleInputField}
                          >
                            <option value="">
                              {strings.selectstatus}
                            </option>
                            <option value={1}>{strings.open}</option>
                            <option value={2}>{strings.close}</option>
                          </select>
                          {formVaild.status && (
                            <span style={{ color: "red" }}>
                              {formVaild.status}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-8">
                        <div className="mb-3">
                          <label htmlFor="exampleFormControlLastName">
                            {strings.description}
                            <span className="required-field"></span>
                          </label>
                          <textarea
                            className="form-control"
                            name="remark"
                            value={form.remark}
                            onChange={handleInputField}
                            id=""
                            cols="74"
                            rows="5"
                          ></textarea>
                          {formVaild.remark && (
                            <span style={{ color: "red" }}>
                              {formVaild.remark}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12 d-flex justify-content-end">
                        <div className="card-footer">
                          <button
                            className="btn btn-color"
                            type="button"
                            onClick={raiseTicketUpdate}
                          >
                            {strings.update}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              )}
              <hr className="class-1" />
              {viewData?.length > 0
                ? viewData.map((item, index) => {
                  return (
                    <div key={index} className="card-body pt-0">
                      <div className="row pt-0">
                        <div className="col-md-3 align-items-center">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.updateBy} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {item?.update_by_name || strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row pt-0">
                        <div className="col-md-3 align-items-center">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.status} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {raiseTicketStatus[item?.status] ||
                              strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr />
                      <div className="row pt-0">
                        <div className="col-md-3 align-items-center">
                          <label htmlFor="exampleInputMobileNo">
                            {strings.description} :
                          </label>
                        </div>
                        <div className="col-md-7 align-items-center">
                          <label
                            htmlFor="exampleInputMobileNo"
                            className="boldText"
                          >
                            {item?.remark || strings.notavailable}
                          </label>
                        </div>
                      </div>
                      <hr className="class-1 mb-0" />
                    </div>
                  );
                })
                : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UpdateStatus;
